<template>
  <div>
    <div class="bind_preamble_box">
      <p class="p1 clearfix"><span>{{$t('preamble.tx13')}}</span></p>
      <div class="table_box">
        <ul>
          <li v-for="(item,index) in infolist"
              :key="index">
            <p class="one-txt-cut">{{$t('logoff.tourText2')}}: {{ item.game }}</p>
            <p class="one-txt-cut">{{$t('logoff.tourText3')}}: {{ item.role_name}}</p>
            <p class="one-txt-cut">{{$t('logoff.tourText4')}}: {{item.role_id}}</p>
            <p class="one-txt-cut">{{$t('logoff.tourText5')}}: {{ item.level }}</p>
          </li>

        </ul>
      </div>
      <li class="form_item form_submit"
          @click="cancelClick"
          ref='form_submit'>
        {{$t('toast.comfirmBtn1')}}
      </li>
    </div>
  </div>
</template>
  
  <script>
import { appPostMessage } from '@/utils/communication'
import { getSessionStorage } from '@/utils/stage'
export default {
  data() {
    return {
      roleInfo: '',
      infolist: [],
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.infolist = JSON.parse(getSessionStorage('userInfo'))
    },
    cancelClick() {
      const info = JSON.parse(getSessionStorage('bindInfo'))
      console.log('info', info)
      const msg = { code: 21, data: info }
      appPostMessage(msg)
    },
  },
}
</script>
  
  <style lang="less" scoped>
.bind_preamble_box {
  width: 100%;
  padding: 30/75rem;
  height: 100%;
  box-sizing: border-box;
  position: relative;
  .p1 {
    font-size: 28/75rem;
    font-weight: 400;
    color: #575757;
    margin-bottom: 30/75rem;
    text-align: center;
    span {
      position: relative;
      display: inline-block;
      padding-left: 50/75rem;
      box-sizing: border-box;
      &::before {
        content: '';
        position: absolute;
        width: 40/75rem;
        height: 40/75rem;
        display: inline-block;
        background: url('../../assets/images/achieved.png') no-repeat;
        background-size: contain;
        left: 0/75rem;
      }
      //   float: left;
      //   width: 40/75rem;
      //   height: 40/75rem;
      //   display: inline-block;
      //   background: url('../../assets/images/achieved.png') no-repeat;
      //   background-size: contain;
    }
  }
  .table_box {
    width: 610/75rem;
    margin: 0 auto;
    overflow: hidden;
    height: calc(100vh - 240px);
    ul {
      width: 100%;
      height: 100%;
      overflow: auto;
      li {
        width: 610/75rem;
        margin-bottom: 10/75rem;
        height: 200/75rem;
        border-radius: 6px 6px 6px 6px;
        border: 1px solid #c7c7c7;
        padding: 20/75rem 35/75rem;
        box-sizing: border-box;

        font-size: 28/75rem;
        font-family: PingFang SC-Bold, PingFang SC;
        font-weight: bold;
        margin-bottom: 20/75rem;
        p {
          margin: 0;
          color: #575757;
          line-height: 40/75rem;
          //   text
        }
      }
    }
  }
}
.form_submit {
  width: 690/75rem;
}
</style>